import { Component, OnInit, Input, Optional, Self } from '@angular/core';
import { FormBuilder, FormGroup, NgControl } from '@angular/forms';
import { ComparableOperator } from 'app/models/form';
import { BaseAnswerTypeComponent } from '../base-answer-type.component';

@Component({
  selector: 'app-date-input',
  templateUrl: './date-input.component.html',
  styleUrls: ['./date-input.component.scss']
})
export class DateInputComponent extends BaseAnswerTypeComponent<number | number[]> implements OnInit {
  formGroup: FormGroup;
  // @Input() controlName: string;
  @Input() label: string;
  @Input() placeholder: string = '';
  @Input() minDate: Date = null;
  @Input() detailMode: boolean = false;
  @Input() readonly: boolean;
  @Input() required: boolean;

  constructor(
    private fb: FormBuilder,
    @Self()
    @Optional()
    ngControl?: NgControl,
  ) {
    super(ngControl);
    this.formGroup = this.fb.group({
      date: null
    });
  }

  ngOnInit() {
  }

  ngAfterViewInit(): void {
    if(this.readonly){
      this.formGroup.disable();
    }

    if(this.required && !this.ngControl.control?.value){
      this.ngControl.control.setErrors({'dateRequired': true});
    }

    if(this.ngControl.control?.value){
      this.formGroup.get('date').setValue(this.ngControl.control?.value);
    }
    
    this.formGroup.valueChanges.subscribe(data => {
      this.ngControl.control.setValue(data.date);
    });
  }

  handleKeyDown(e: KeyboardEvent){
    if(e.code !== "Backspace"){
      e.preventDefault();
      return;
    }
  }

  getError(errorCode: string) {
    // Enables the control for getting the error properly

    // this.formGroup.get(this.controlName).enable();
    // const hasError: boolean = this.formGroup.get(this.controlName).hasError(errorCode);
    // this.formGroup.get(this.controlName).disable();
    // return hasError;
  }

  AllowedOperators: {[K in ComparableOperator]: (target: number, value: string) => boolean} = {
    [ComparableOperator.Equal]: (t, value: string) => t == Number(value),
    [ComparableOperator.NotEqual]: (t, value) => t != Number(value),
    [ComparableOperator.Contains]: null,
    [ComparableOperator.StartWith]: null,
    [ComparableOperator.EndWith]: null,
    [ComparableOperator.In]: (t, value: string) => value.split(";").map(v => Number(v)).includes(t),
    [ComparableOperator.GreaterThan]: null,
    [ComparableOperator.GreaterThanOrEqual]: null,
    [ComparableOperator.LessThan]: null,
    [ComparableOperator.LessThanOrEqual]: null,
    [ComparableOperator.IsNullOrEmpty]: (t) => !t,
    [ComparableOperator.NotIsNullOrEmpty]: (t) => !!t,
    [ComparableOperator.Between]: null,
  }

}
